export default {
    props: {
        /**
         * Slice id
         */
        id: {
            type: String,
        },

        /**
         * Slice title
         */
        title: {
            type: String,
        },

        /**
         * Slice title tag
         */
        titleTag: {
            type: String,
            default: 'h2',
            validator: (value) => ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'p'].includes(value),
        },

        /**
         * Slice lead
         */
        lead: {
            type: String,
        },

        /**
         * Slice body text
         */
        bodyText: {
            type: String,
        },
    },

    inheritAttrs: false,
};
